import { memo, useContext, useRef } from "react";

import classes from "./RecipeBookOpen.module.css";

import Modal from "../../../UI/Modal";
import RecipeHeader from "../../RecipeCard/RecipeHeader/RecipeHeader";
import RecipeBody from "../../RecipeCard/Recipe_Body/RecipeBody";
import DrinkContentsPage from "./DrinkContentsPage/DrinkContentsPage";
import IngredientContentsPage from "./IngredientContentsPage/IngredientContentsPage";
import FrontPage from "./FrontPage/FrontPage";

import ShelfContext from "../../../store/shelf-context";

// component for open cocktail book
const RecipeBookOpen = (props) => {
  const shelfCtx = useContext(ShelfContext);
  const scrollRef = useRef(null);

  const book = props.book;

  // map each cocktail in the book to to a recipe page
  const bookCocktails = book.items.map((item, i) => {
    console.log("recipe book open:", item);
    return (
      <div className={classes.recipe_page} key={i}>
        <div className={classes.page_header}>
          <RecipeHeader key={item.title} title={item.title} />
        </div>
        <div className={classes.page_body}>
          <RecipeBody key={item.title} drink={item} />
        </div>
      </div>
    );
  });

  // delete the book from local storage
  const deleteBookHandler = () => {
    shelfCtx.deleteBook(book.id);
    shelfCtx.saveBooks();
  };

  const scrollTo = (direction) => {
    console.log("running scroll to: ", direction);
    if (scrollRef.current) {
      const scrollAmount = scrollRef.current.clientWidth;
      scrollRef.current.scrollBy({
        left: direction === "next" ? scrollAmount : -scrollAmount,
        behavior: "smooth",
      });
    }
  };

 

  return (
    <Modal onClose={props.onClose}>
      <div
        style={{ backgroundColor: ` ${book.colour}` }}
        className={classes.book_spine}
      >
        <div className={classes.recipe_book} ref={scrollRef}>
          <div className={classes.page}>
            {<FrontPage title={book.title} colour={book.colour} />}
          </div>
          <div className={classes.page}>
            <DrinkContentsPage
              drinks={book.items}
              deleteBook={deleteBookHandler}
            />
          </div>
          <div className={classes.page}>
            <IngredientContentsPage ingredients={book.ingredients} />
          </div>
          {bookCocktails.map((cocktail, index) => (
            <div className={classes.page} key={index}>
              {cocktail}
            </div>
          ))}
        </div>

        <div
          onClick={() => scrollTo("prev")}
      
          className={classes.scroll_button_left}
        >
          {"<-"}
        </div>
        <div
          onClick={() => scrollTo("next")}
          className={classes.scroll_button_right}
        >
          {"->"}
        </div>
      </div>
    </Modal>
  );
};

export default memo(RecipeBookOpen);
